import { useLayoutEffect, useRef, useState } from "react";

/**
 * A hook which checks and updates if an element's content has vertical overflow.
 *
 * @param {object} ref
 * @returns {boolean}
 */
const useIsOverflowing = (ref) => {
	const resizeObserver = useRef(null);
	const [isOverflowing, setIsOverflowing] = useState(undefined);

	useLayoutEffect(() => {
		const { current } = ref || {};

		const update = () => {
			setIsOverflowing(current.scrollHeight > current.clientHeight);
		};

		if (current) {
			if ("ResizeObserver" in window) {
				resizeObserver.current = new ResizeObserver(update).observe(current);
			}
			update();
		}

		return () => {
			if (resizeObserver.current) {
				resizeObserver.current.disconnect();
			}
		};
	}, [ref]);

	return isOverflowing;
};

export default useIsOverflowing;
